import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { roleGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', loadComponent: () => import('./pages/login-select/login-select.page').then(m => m.LoginSelectPage) },
  { path: 'auth/pin',    loadComponent: () => import('./pages/auth/pin/pin.page').then(m => m.PinPage) },
  { path: 'auth/email',  loadComponent: () => import('./pages/auth/email/email.page').then(m => m.EmailPage) },
  { path: 'auth/verify', loadComponent: () => import('./pages/auth/verify/verify.page').then(m => m.VerifyPage) },
  { path: 'ob/:serial',  loadComponent: () => import('./pages/ob-scan/ob-scan.page').then(m => m.ObScanPage) },
  { path: 'gm',          canActivate: [roleGuard('gm')], loadChildren: () => import('./pages/gm/gm.routes').then(m => m.routes) },
  { path: 'hub',         canActivate: [roleGuard('hub_manager')], loadChildren: () => import('./pages/hub/hub.routes').then(m => m.routes) },
  { path: 'collector',   canActivate: [roleGuard('collector')], loadChildren: () => import('./pages/collector/collector.routes').then(m => m.routes) },
  { path: 'post-office', canActivate: [roleGuard('post_office')], loadChildren: () => import('./pages/post-office/po.routes').then(m => m.routes) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
